<template>
  <div class="modal-overlay">
    <div
      ref="kt_modal_auditoria_detalhes"
      data-bs-backdrop="static"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
      id="kt_modal_auditoria_detalhes"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <div class="card-title d-flex align-items-center">
              <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
                <inline-svg src="media/icons/duotune/general/gen062.svg" />
              </span>
              <h3 class="fw-bold m-0 text-gray-800">Detalhes</h3>
            </div>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="$emit('exibirModalAuditoriaDetalhes', false)"
            >
              <span class="svg-icon svg-icon-1 svg-icon lh-0">
                <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-8">
            <div v-if="this.auditoria.valores_antigos" class="mb-6 fv-row">
              <label :for="`valores_antigos`" class="form-label"
                >Valores Antigos</label
              >
              <JsonViewer
                :value="JSON.parse(this.auditoria.valores_antigos)"
                :copyable="true"
                :boxed="true"
                :sort="true"
                :expanded="true"
                :theme="theme"
                @copied="this.copyToClipboard($event.text)"
              />
            </div>
            <div v-if="this.auditoria.valores_novos" class="mb-6 fv-row">
              <label :for="`valores_novos`" class="form-label"
                >Valores Novos</label
              >
              <JsonViewer
                :value="JSON.parse(this.auditoria.valores_novos)"
                :copyable="true"
                :boxed="true"
                :sort="true"
                :expanded="true"
                :theme="theme"
                @copied="this.copyToClipboard($event.text)"
              />
            </div>
            <div v-if="this.auditoria.colunas_afetadas" class="mb-6 fv-row">
              <label :for="`colunas_afetadas`" class="form-label"
                >Colunas Afetadas</label
              >
              <JsonViewer
                :value="JSON.parse(this.auditoria.colunas_afetadas)"
                :copyable="true"
                :boxed="true"
                :sort="true"
                :expanded="true"
                :theme="theme"
                @copied="this.copyToClipboard($event.text)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { JsonViewer } from "vue3-json-viewer";
import "vue3-json-viewer/dist/index.css";

export default {
  emits: ["exibirModalAuditoriaDetalhes"],
  components: { JsonViewer },
  props: {
    auditoria: { type: Object, required: true },
  },
  methods: {
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
      } catch (error) {
        console.log(error);
      }
    },
  },
  data() {
    return {
      theme: localStorage.getItem("kt_theme_mode_menu"),
    };
  },
};
</script>

<style></style>
